var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" image url transfer to blob "),_c('div',{staticClass:"demo",attrs:{"id":"forAppend"}})])
}]

export { render, staticRenderFns }